import { useState, useEffect } from "react";
import { IconButton, Tooltip, CircularProgress } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import useApi from "../../hooks/useApi";
import MarkdownViewer from "./MarkdownViewer";

const DocumentationIcon = ({ pageName }) => {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openViewer, setOpenViewer] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const { postData } = useApi();

  // Fetch documentation for this page on mount
  useEffect(() => {
    const fetchDocs = async () => {
      if (!pageName) return;

      try {
        setLoading(true);
        const response = await postData({
          url: "/api/entity",
          entityName: "Documentation",
          action: "getByPage",
          data: { pageName },
        });

        if (response && response.data) {
          setDocs(
            Array.isArray(response.data) ? response.data : [response.data]
          );
        }
      } catch (error) {
        console.error("Error fetching documentation:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDocs();
  }, [pageName]); // Remove postData from dependencies

  // Hide icon if no docs or if still loading
  if (loading || docs.length === 0) {
    return null;
  }

  const handleIconClick = () => {
    // If only one doc, open it directly
    if (docs.length === 1) {
      setSelectedDoc(docs[0]);
      setOpenViewer(true);
    } else {
      // Multiple docs - open viewer to select
      setOpenViewer(true);
    }
  };

  return (
    <>
      <Tooltip
        title={`${docs.length} documentation${
          docs.length > 1 ? "s" : ""
        } available`}
      >
        <IconButton
          onClick={handleIconClick}
          size="small"
          sx={{ color: "white" }}
        >
          <HelpIcon />
        </IconButton>
      </Tooltip>

      {openViewer && (
        <MarkdownViewer
          open={openViewer}
          onClose={() => {
            setOpenViewer(false);
            setSelectedDoc(null);
          }}
          docs={docs}
          selectedDoc={selectedDoc}
          onDocSelect={setSelectedDoc}
        />
      )}
    </>
  );
};

export default DocumentationIcon;
